// extracted by mini-css-extract-plugin
export default {"container":"NoticeMW_container__CgAtE","title":"NoticeMW_title__ksLQA","text":"NoticeMW_text__OM7cj","btn_container":"NoticeMW_btn_container__39lK2"};